import { render } from "./GroupItem.vue?vue&type=template&id=c404da2a&scoped=true"
import script from "./GroupItem.vue?vue&type=script&lang=js"
export * from "./GroupItem.vue?vue&type=script&lang=js"

import "./GroupItem.vue?vue&type=style&index=0&id=c404da2a&scoped=true&lang=css"

import exportComponent from "/home/falken/code/web/ipronet-vsaas/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c404da2a"]])

export default __exports__